// extracted by mini-css-extract-plugin
module.exports = {"Product":"mini_Product__l4Kqg","ProductPhoto":"mini_ProductPhoto__gHRgF","ProductInfo":"mini_ProductInfo__QqVRN"};